export class GeorefNotSetError extends Error {
  constructor(message = 'Georef must be saved to the upload store at this point') {
    super(message);
    this.name = 'GeorefNotSetError';
  }
}
